module.exports = __webpack_public_path__ + "img/flamingo.0cad8379.png";